import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
// import moment from "moment";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllContainerImportDischarge = createAsyncThunk(
  "ContainerImportDischarge/FindAllContainerImportDischarge",
  async (ContainerImportDischargeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ContainerImportDischarge/FindAllContainerImportDischarge`,
        ContainerImportDischargeData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Container Import Discharges:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createContainerImportDischarge = createAsyncThunk(
  "ContainerImportDischarge/InsertContainerImportDischarge",
  async (ContainerImportDischargeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ContainerImportDischarge/InsertContainerImportDischarge`,
        ContainerImportDischargeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Container Import Discharge:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateContainerImportDischarge = createAsyncThunk(
  "ContainerImportDischarge/UpdateContainerImportDischarge",
  async (ContainerImportDischargeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ContainerImportDischarge/UpdateContainerImportDischarge`,
        ContainerImportDischargeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Container Import Discharge:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteContainerImportDischarge = createAsyncThunk(
  "ContainerImportDischarge/DeleteContainerImportDischarge",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ContainerImportDischarge/DeleteContainerImportDischarge`,
        { shipping_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Container Import Discharge:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getContainerImportDischargeByID = createAsyncThunk(
  "ContainerImportDischarge/FindByIDContainerImportDischarge",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ContainerImportDischarge/FindByIDContainerImportDischarge`,
        { shipping_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        // form_type: result.form_type,
        id: result?.id,
        shipping_guid: result?.shipping_guid,
        eta: result?.eta ? moment(result?.eta, "YYYY-MM-DD").toDate() : "",
        vessels_name: result?.vessels_name,
        agent_id: result?.agent_id
          ? result?.agent_id.split(",").map(Number)
          : [],
        cargo: result?.cargo,
        vcn: result?.vcn,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Container Import Discharge:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
